import usePhaserGame from '../../../hooks/usePhaserGame';
import PantallaCarga from './JuegoBlackJack/PantallaCarga';
import JuegoBlackJack from './JuegoBlackJack/JuegoBlackJack';

const PhaserBlackJack = () => {
  const containerRef = usePhaserGame({
    scenes: [PantallaCarga, JuegoBlackJack],
    width: 1000,
    height: 500,
    useSaldoDirecto: true,
  });

  return <div ref={containerRef} id="phaser-blackjack" />;
};

export default PhaserBlackJack;
